var CompanySize = {
	"Company size": "Şirket Büyüklüğü",
	"1-19 employees": "1-19 Çalışan",
	"20-99 employees": "20-99 Çalışan",
	"100-499 employees": "100-499 Çalışan",
	"500-999 employees": "500-999 Çalışan",
	"1,000-9,999 employees": "1.000-9.999 Çalışan",
	"10,000 employees or more": "10.000 ve Üzeri Çalışan"
};

export { CompanySize as default };
